export const getFrontDomain = () => {
  if (
    // eslint-disable-next-line
    !window.hasOwnProperty("frontDomain") ||
    typeof window.frontDomain === "undefined" ||
    window.frontDomain === "undefined" ||
    !window.frontDomain
  ) {
    return "";
  }

  return window.frontDomain.replace(/\/+$/, "");
};
